<div class="c-day-header__date">
    <span class="c-day-header__date-month">{{monthName}}</span>
    {{dayNumber}}
</div>
<div class="c-day-header__day">{{dayName}}</div>
